import { useSelector, useDispatch } from 'react-redux';



const useAuth = () => {
  

    const auth = {
        name: useSelector((state) => state.globalData.name),
        email: useSelector((state) => state.globalData.email),
        token: useSelector((state) => state.globalData.token),
       
    }

    return {auth}
}

export default useAuth;

